import React from 'react'
import LoginMethodFrame from '../shared/LoginMethodFrame'
import { AuthMethodEnum, onMethodChange } from '../../types.d'
import { useAppSelector, selectSigninData } from '../../store/store'
import { preventDefault } from '../../helpers'
import { InjectedAuthProps, withAuthProps } from '../../context/withAuthProps'

const AUTH_METHODS_TO_HUMAN_NAMES: Record<
  Exclude<AuthMethodEnum, AuthMethodEnum.UNAVAILABLE>,
  string
> = {
  [AuthMethodEnum.PASSWORD]: 'Enter your password',
  [AuthMethodEnum.EMAIL_OTP]: 'Enter a code sent to your email',
  [AuthMethodEnum.PASSKEY]: 'Use a passkey',
}

type PureMethodSelectorProps = {
  authMethods: AuthMethodEnum[]
  onMethodChange: onMethodChange
} & InjectedAuthProps

export const PureMethodSelector = ({
  authMethods,
  onMethodChange,
  ...props
}: PureMethodSelectorProps) => (
  <LoginMethodFrame
    title="Choose a way to sign in"
    recoveryPrompt="None of these working?"
    recoveryText="Contact support"
    onMethodChange="mailto:support@tidyhq.com"
    {...{ ...props }}
  >
    <ul className="max-w-md divide-y divide-gray-200">
      {authMethods.map((method) => (
        <li className="p-3 sm:p-4" key={method}>
          <a
            onClick={preventDefault(onMethodChange(method))}
            href="#"
            className="text-sm font-medium text-blue-600 hover:underline truncatee"
          >
            {AUTH_METHODS_TO_HUMAN_NAMES[method]}
          </a>
        </li>
      ))}
    </ul>
  </LoginMethodFrame>
)

const BoundMethodSelector = withAuthProps(PureMethodSelector)

export const MethodSelector = () => {
  const signinData = useAppSelector(selectSigninData)

  if (!signinData?.userInfo) {
    return null // This shouldn't happen but provides type safety
  }

  const { authMethods } = signinData.userInfo

  return <BoundMethodSelector authMethods={authMethods} />
}

export default MethodSelector
